<template>
  <div class="social-login">
    <div class="social-buttons">
      <button
        class="social-button google"
        @click.prevent="loginWithProvider('google')"
      >
        <svg fill="none" viewBox="0 0 24 24" width="20" height="20">
          <path
            fill="#4285F4"
            d="M23.754 12.23c0-.852-.06-1.625-.204-2.417H12.24v4.646h6.46c-.277 1.5-1.13 2.774-2.402 3.626v3.014h3.878c2.27-2.09 3.578-5.163 3.578-8.825v-.043Z"
          ></path>
          <path
            fill="#34A853"
            d="M12.24 24.004c3.242 0 5.955-1.08 7.948-2.905l-3.878-3.014c-1.08.72-2.449 1.14-4.07 1.14-3.121 0-5.775-2.113-6.723-4.946h-4.01v3.11c1.98 3.926 6.039 6.615 10.733 6.615Z"
          ></path>
          <path
            fill="#FBBC04"
            d="M5.517 14.279a7.21 7.21 0 0 1-.372-2.281c0-.792.132-1.56.372-2.281v-3.11h-4.01a11.964 11.964 0 0 0-1.273 5.39c0 1.934.468 3.77 1.273 5.392l4.01-3.11Z"
          ></path>
          <path
            fill="#E94235"
            d="M12.24 4.77c1.765 0 3.35.6 4.586 1.801l3.446-3.445C18.195 1.193 15.47.004 12.24.004 7.546-.008 3.488 2.68 1.507 6.607l4.01 3.11c.948-2.834 3.59-4.947 6.723-4.947Z"
          ></path>
        </svg>
        {{ $t("user.continueWithGoogle") }}
      </button>
      <!-- <button
        class="social-button facebook"
        @click.prevent="loginWithProvider('facebook')"
      >
        <svg fill="none" viewBox="0 0 24 24" width="20" height="20">
          <path
            fill="#0866FF"
            d="M24 12.004c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.627 3.875 10.35 9.101 11.647v-7.98H6.627v-3.667H9.1v-1.58c0-4.084 1.849-5.977 5.858-5.977.76 0 2.073.149 2.61.298v3.324c-.284-.03-.776-.045-1.387-.045-1.967 0-2.728.745-2.728 2.683v1.297h3.92l-.674 3.667h-3.246v8.245C19.396 23.198 24 18.139 24 12.004Z"
          ></path>
          <path
            fill="#fff"
            d="m16.7 15.671.673-3.667h-3.92v-1.297c0-1.938.761-2.683 2.728-2.683.611 0 1.104.015 1.387.044V4.745c-.537-.15-1.849-.299-2.61-.299-4.009 0-5.857 1.894-5.857 5.978v1.58H6.626v3.667h2.475v7.98a12.021 12.021 0 0 0 4.352.265V15.67H16.7Z"
          ></path>
        </svg>
        {{ $t("user.continueWithFacebook") }}
      </button> -->
    </div>
    <div class="social-divider">
      <span>{{ $t("user.orLoginWith") }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: "loginSuccess", payload: { action: "login" | "register" }): void;
}>();

const loginWithProvider = (provider: string) => {
  const width = 600;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  const popup = window.open(
    `/auth/${provider}`,
    "SocialLogin",
    `width=${width},height=${height},top=${top},left=${left}`
  );

  const interval = setInterval(() => {
    if (!popup || popup.closed) {
      clearInterval(interval);
      window.removeEventListener("message", handleMessage);
    }
  }, 500);

  const handleMessage = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;

    if (event.data.status === "socialSuccess") {
      clearInterval(interval);
      popup?.close();
      window.removeEventListener("message", handleMessage);

      emit("loginSuccess", {
        action: event.data.action,
      });
    }
  };

  window.addEventListener("message", handleMessage);
};
</script>

<style lang="scss" scoped>
.social-login {
  text-align: center;
}

.social-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1.5rem 0;
}

.social-divider::before,
.social-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ccc;
  margin: 0 0.75rem;
}

.social-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.social-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.15rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.social-button img {
  height: 20px;
  width: 20px;
}

.social-button.google {
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
}

.social-button.google:hover {
  background: #f7f7f7;
}

.social-button.facebook {
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
}

.social-button.facebook:hover {
  background: #f7f7f7;
}
</style>
